<template>
  <div 
      class="bg-[#E5E5E5] border-[#D1D1D1]
        fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 
        w-3/4 [@media(min-width:768px)]:w-1/3 h-3/4 bg-white rounded-2xl shadow-xl flex flex-col overflow-hidden rounded-[30px]"
    >
        <slot />
  </div>
</template>
